import { useGetCallbackHealth } from 'services/hooks/queries';
import { formatMillisecondsAsDayHourMinSec } from 'utils/dateformat.utils';
import { Clock, TriangleAlert, ChartColumn } from 'lucide-react';
import { Tooltip } from 'common/components';
import styles from './CallbackMetricks.module.scss';

export const CallbackMetrics = () => {
    const { callbackHealthData, isCallbackHealthLoading } = useGetCallbackHealth();

    const hasOverdue = !!callbackHealthData?.overdue24hTotal;

    return (
        <div className={styles.callbackMetricsContainer}>
            <h5 className={styles.callbackMetricsTitle}>Callback Metrics</h5>

            <div className='flex items-stretch gap-md mt-md flex-wrap'>
                <div className={styles.callbackMetricsItem}>
                    <p className={styles.callbackMetricsItemText}>
                        <span className={styles.callbackMetricsItemIcon}>
                            <Clock size={16} color='var(--primary-purple)' />
                        </span>
                        Pending
                    </p>
                    <h4>{callbackHealthData?.pendingTotal}</h4>
                </div>

                <div className={styles.callbackMetricsItem}>
                    <p className={styles.callbackMetricsItemText}>
                        <span className={styles.callbackMetricsItemIcon}>
                            <ChartColumn size={16} color='var(--primary-purple)' />
                        </span>
                        Average Wait
                    </p>
                    <h4>
                        {isCallbackHealthLoading
                            ? '—'
                            : formatMillisecondsAsDayHourMinSec(Number(callbackHealthData?.avgQueueTimeMilliseconds))}
                    </h4>
                </div>
                <Tooltip content='More than 24 hours old' position='top'>
                    <div
                        className={`${styles.callbackMetricsItem} ${hasOverdue ? styles.callbackMetricsItem_error : ''}`}
                    >
                        <p className={styles.callbackMetricsItemText}>
                            <span className={styles.callbackMetricsItemIcon}>
                                <TriangleAlert size={16} color='var(--error-color)' />
                            </span>
                            Overdue
                        </p>
                        <h4 className={hasOverdue ? 'text-error' : ''}>{callbackHealthData?.overdue24hTotal}</h4>
                    </div>
                </Tooltip>
            </div>
        </div>
    );
};
